import { domainTips } from "@/mocks/homeContent";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function DomainCheckSection() {
  return (
    <section id="domain" className="w-full bg-foreground-950 py-14 text-background-50 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-start">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 font-label text-xs font-medium text-background-50">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-shield-check-line text-xs"></i>
              </span>
              辨别与安全
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">
              新域名是多少？先学会辨别真假
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-background-300 md:text-base">
              与其死记某个具体域名，不如掌握一套辨别方法。新域名会随地址更换而变化，真正可靠的做法是认准官方公告与固定入口，对来路不明的链接保持警惕。
            </p>

            <div className="mt-6 rounded-lg border border-white/15 bg-white/5 p-4">
              <p className="flex items-center gap-2 font-label text-sm font-medium text-primary-300">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-alert-line"></i>
                </span>
                一句话原则
              </p>
              <p className="mt-2 text-sm leading-relaxed text-background-200">
                地址可以变，来源不能将就。优先从固定入口进入，而不是直接点开陌生链接。
              </p>
            </div>
          </div>

          <div className="space-y-3">
            {domainTips.map((tip, index) => (
              <div
                key={tip.title}
                className="flex gap-4 rounded-lg border border-white/10 bg-white/5 p-4 transition-colors hover:border-accent-400/60 md:p-5"
              >
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-accent-500 font-label text-sm font-bold text-background-50">
                  {index + 1}
                </span>
                <div className="min-w-0">
                  <h3 className="font-heading text-base font-bold text-background-50">{tip.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-background-300">{tip.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}